import { render, staticRenderFns } from "./SortedPackages.vue?vue&type=template&id=ce40e5f4&scoped=true"
import script from "./SortedPackages.vue?vue&type=script&lang=js"
export * from "./SortedPackages.vue?vue&type=script&lang=js"
import style0 from "./SortedPackages.vue?vue&type=style&index=0&id=ce40e5f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce40e5f4",
  null
  
)

export default component.exports